module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lessons__filters"
  }, [_c('div', {
    staticClass: "lessons__filters__filter",
    class: {
      'lessons__filters__filter--active': _vm.activeFilter === 'draft'
    },
    on: {
      "click": function($event) {
        return _vm.setFilter('draft')
      }
    }
  }, [_vm._v("Efterbehandling (" + _vm._s(_vm.userDaysDrafts.length) + ")\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "lessons__filters__filter",
    class: {
      'lessons__filters__filter--active': _vm.activeFilter === 'approved'
    },
    on: {
      "click": function($event) {
        return _vm.setFilter('approved')
      }
    }
  }, [_vm._v("Godkendt (" + _vm._s(_vm.userDaysApproved.length) + ")\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "lessons__filters__filter",
    class: {
      'lessons__filters__filter--active': _vm.activeFilter === 'sent'
    },
    on: {
      "click": function($event) {
        return _vm.setFilter('sent')
      }
    }
  }, [_vm._v(_vm._s(_vm.isSalaryIntegrationActive ? 'Sendt til lønsystem' : 'Er indberettet') + " (" + _vm._s(_vm.userDaysSent.length) + ")\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b700d4fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalaryFilters.vue
// module id = 1750
// module chunks = 1